(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-status"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('impact-order-status')) {
    const ICONS = {
      check: '<path d="M5 12.5l4.5 4.5L19 7.5"/>',
      alert: '<path d="M12 8v5M12 16.5v.01"/><circle cx="12" cy="12" r="9"/>',
      ORDER_PLACED: '<path d="M9 5h6M9 3h6a1 1 0 011 1v1H8V4a1 1 0 011-1z"/><path d="M8 5H6a1 1 0 00-1 1v14a1 1 0 001 1h12a1 1 0 001-1V6a1 1 0 00-1-1h-2M9 13l2 2 4-4"/>',
      KIT_SHIPPED: '<path d="M21 8l-9-5-9 5 9 5 9-5zM3 8v8l9 5 9-5V8M12 13v8"/>',
      IMPRESSION_RECEIVED: '<path d="M4 12c0-4 3.5-7 8-7s8 3 8 7c0 2-1 3-2.5 3S15 14 12 14s-4 1-5.5 1S4 14 4 12z"/><path d="M8 11v1M12 10v1.5M16 11v1"/>',
      IMPRESSION_REVIEW: '<circle cx="11" cy="11" r="6"/><path d="M20 20l-4.5-4.5"/>',
      IN_PRODUCTION: '<path d="M12 3l1.8 4.2L18 9l-4.2 1.8L12 15l-1.8-4.2L6 9l4.2-1.8L12 3zM18 15l.9 2.1L21 18l-2.1.9L18 21l-.9-2.1L15 18l2.1-.9L18 15z"/>',
      READY_TO_SHIP: '<path d="M4 7l8-4 8 4v10l-8 4-8-4V7z"/><path d="M4 7l8 4 8-4M12 11v10"/><path d="M8 5l8 4"/>',
      SHIPPED: '<path d="M3 6h11v10H3zM14 9h4l3 3v4h-7"/><circle cx="7" cy="17.5" r="1.5"/><circle cx="17.5" cy="17.5" r="1.5"/>',
      refresh: '<path d="M20 11a8 8 0 10-2.3 5.7M20 4v7h-7"/>',
      chevron: '<path d="M6 9l6 6 6-6"/>',
      search: '<circle cx="11" cy="11" r="6"/><path d="M20 20l-4.5-4.5"/>',
    };

    // Customer copy for each stage; `current` / `attention` / `done` override the default.
    const COPY = {
      ORDER_PLACED: { default: "We've got your order and are getting your fit kit ready." },
      KIT_SHIPPED: { default: 'Your fit kit is on its way. Follow the guide inside to take your impression.' },
      IMPRESSION_RECEIVED: { default: 'Your impression has arrived at our lab.' },
      IMPRESSION_REVIEW: {
        current: 'Our lab team is checking your impression for a perfect fit.',
        attention: 'We need a new impression. Check your email for next steps.',
        default: 'Your impression passed our fit check.',
      },
      IN_PRODUCTION: { default: 'Your mouthguard is being custom made in our lab.' },
      READY_TO_SHIP: { default: 'Finished, quality checked and being packed for you.' },
      SHIPPED: { default: 'Your mouthguard is on its way to you.' },
    };

    const svg = (name) => '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' + (ICONS[name] || '') + '</svg>';

    class ImpactOrderStatus extends HTMLElement {
      connectedCallback() {
        this.endpoint = this.dataset.endpoint;
        this.form = this.querySelector('.ios__form');
        this.message = this.querySelector('.ios__message');
        this.results = this.querySelector('.ios__results');
        this.lastQuery = null;
        this.open = new Set();
        this.seen = new Set();

        this.form.addEventListener('submit', (e) => {
          e.preventDefault();
          const order = this.form.elements.order.value.trim();
          const email = this.form.elements.email.value.trim();
          if (!order || !email) return this.showMessage('Please enter your order number and email.', true);
          this.load({ order, email });
        });

        // Stages come live from the order, so refresh when the customer comes back to the tab.
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible' && this.lastQuery) this.load(this.lastQuery, true);
        });

        if (this.dataset.signedIn === 'true') this.load({});
      }

      async load(query, quiet = false) {
        this.lastQuery = query;
        const button = this.form.querySelector('button');
        button.disabled = true;
        this.classList.add('is-loading');
        this.results.setAttribute('aria-busy', 'true');
        if (!quiet) {
          this.showMessage('');
          if (!this.results.querySelector('.ios__card:not(.ios__skeleton)')) this.results.replaceChildren(this.renderSkeleton());
        }
        try {
          const url = this.endpoint + (Object.keys(query).length ? '?' + new URLSearchParams(query) : '');
          // ngrok-skip-browser-warning: Shopify forwards it, so a free ngrok tunnel (dev) skips its
          // warning page. Ignored everywhere else; safe to leave in production.
          const res = await fetch(url, {
            headers: { Accept: 'application/json', 'ngrok-skip-browser-warning': '1' },
            cache: 'no-store',
          });
          const data = await res.json().catch(() => null);
          // Anything that isn't the app's JSON (e.g. Shopify's 404 page) means the app proxy isn't reachable.
          if (!data) {
            console.warn('[order-status] ' + url + ' returned HTTP ' + res.status + ' without app data. Check the app proxy is set up and matches the section\'s "App proxy path" setting.');
            return this.fail("We couldn't load your order status right now. Please try again shortly.");
          }
          if (data.error === 'not_found') {
            this.results.replaceChildren();
            return this.showMessage("We couldn't find an order with that number and email. Check both and try again.", true);
          }
          if (res.status === 429) return this.fail('Too many attempts. Please wait a few minutes and try again.');
          if (!res.ok) return this.fail("We couldn't load your order status right now. Please try again shortly.");

          const orders = data.orders || [];
          if (orders.length === 0) {
            this.form.hidden = false;
            this.results.replaceChildren();
            return this.showMessage(
              data.mode === 'customer' ? "We couldn't find a custom mouthguard order on your account. You can look one up below." : ''
            );
          }
          this.showMessage('');
          if (this.dataset.expand === 'true' && orders.length === 1) this.open.add(orders[0].orderNumber);
          this.results.replaceChildren(...orders.map((o, i) => this.renderOrder(o, i)));
        } catch (err) {
          this.fail("We couldn't load your order status right now. Please try again shortly.");
        } finally {
          button.disabled = false;
          this.classList.remove('is-loading');
          this.results.removeAttribute('aria-busy');
        }
      }

      fail(text) {
        this.results.querySelector('.ios__skeleton')?.remove();
        this.showMessage(text, true);
      }

      showMessage(text, isError = false) {
        this.message.textContent = text;
        this.message.classList.toggle('ios__message--error', isError);
      }

      formatDate(iso, withYear = true) {
        if (!iso) return '';
        const lang = document.documentElement.lang || undefined;
        const opts = { day: 'numeric', month: 'short' };
        if (withYear) opts.year = 'numeric';
        return new Intl.DateTimeFormat(lang, opts).format(new Date(iso));
      }

      relative(iso) {
        const days = Math.round((Date.now() - Date.parse(iso)) / 86400000);
        if (!Number.isFinite(days)) return '';
        if (days < 1) return 'today';
        const lang = document.documentElement.lang || undefined;
        return new Intl.RelativeTimeFormat(lang, { numeric: 'auto' }).format(-days, 'day');
      }

      el(tag, className, text) {
        const node = document.createElement(tag);
        if (className) node.className = className;
        if (text != null) node.textContent = text;
        return node;
      }

      /** Detailed stages from the app, or the older 5-step list when the app hasn't been updated. */
      timelineOf(o) {
        if (Array.isArray(o.timeline) && o.timeline.length) return o.timeline;
        const keys = ['ORDER_PLACED', 'KIT_SHIPPED', 'IMPRESSION_RECEIVED', 'IN_PRODUCTION', 'SHIPPED'];
        return o.steps.map((s, i) => ({ ...s, key: keys[i] }));
      }

      describe(stage) {
        const copy = COPY[stage.key] || {};
        return copy[stage.state] || copy.default || '';
      }

      renderSkeleton() {
        const card = this.el('div', 'ios__card ios__skeleton');
        card.setAttribute('aria-hidden', 'true');
        [['30%'], ['60%'], ['85%']].forEach(([w]) => {
          const b = this.el('span', 'ios__bone');
          b.style.width = w;
          card.append(b);
        });
        const row = this.el('div', 'ios__bone-row');
        for (let i = 0; i < 7; i++) row.append(this.el('span', 'ios__bone'));
        card.append(row);
        card.append(this.el('span', 'ios__visually-hidden', 'Checking your order…'));
        return card;
      }

      renderOrder(o, index) {
        const timeline = this.timelineOf(o);
        const total = timeline.length;
        let active = 0;
        timeline.forEach((s, i) => { if (s.state !== 'upcoming') active = i; });
        const complete = timeline.every((s) => s.state === 'done');
        const attention = timeline.some((s) => s.state === 'attention');
        const activeStage = timeline[active];

        const card = this.el('article', 'ios__card');
        card.setAttribute('aria-label', 'Order ' + o.orderNumber);
        // Animate in only the first time an order appears, not on every background refresh.
        if (!this.seen.has(o.orderNumber)) {
          card.classList.add('ios__card--enter');
          card.style.setProperty('--card-i', index);
          this.seen.add(o.orderNumber);
        }

        // Header: order number, headline, pill
        const head = this.el('div', 'ios__card-head');
        head.append(this.el('h2', 'ios__order', 'Order ' + o.orderNumber + ' · Placed ' + this.formatDate(o.createdAt)));
        const tone = complete ? 'success' : attention || o.notice ? 'warning' : 'progress';
        const pillText = complete ? 'Shipped' : attention ? 'Action needed' : o.notice ? 'On hold' : 'In progress';
        head.append(this.el('span', 'ios__pill ios__pill--' + tone, pillText));
        card.append(head);
        card.append(this.el('p', 'ios__status', o.statusLabel));
        card.append(this.el('p', 'ios__desc', this.describe(activeStage)));

        if (o.notice) {
          const notice = this.el('p', 'ios__notice');
          notice.innerHTML = svg('alert');
          notice.append(this.el('span', null, o.notice));
          card.append(notice);
        }

        // Horizontal stepper (visual overview; the details list below is the accessible version)
        const track = this.el('ol', 'ios__track' + (complete ? ' ios__track--complete' : ''));
        track.setAttribute('aria-hidden', 'true');
        track.style.setProperty('--n', total);
        const rail = this.el('span', 'ios__rail');
        const fill = this.el('span', 'ios__rail-fill');
        rail.append(fill);
        track.append(rail);
        timeline.forEach((s, i) => {
          const node = this.el('li', 'ios__node ios__node--' + s.state);
          node.style.setProperty('--i', i);
          node.title = s.label + (s.at ? ' · ' + this.formatDate(s.at) : '');
          const icon = this.el('span', 'ios__node-icon');
          icon.innerHTML = svg(s.state === 'done' ? 'check' : s.state === 'attention' ? 'alert' : s.key);
          node.append(icon, this.el('span', 'ios__node-label', s.label));
          node.addEventListener('click', () => this.reveal(card, i));
          track.append(node);
        });
        card.append(track);
        const progress = total > 1 ? active / (total - 1) : 1;
        requestAnimationFrame(() => requestAnimationFrame(() => track.style.setProperty('--p', progress)));

        // Meta row: progress summary + actions
        const meta = this.el('div', 'ios__meta');
        const summary = this.el('span');
        summary.append('Step ');
        summary.append(this.el('strong', null, active + 1 + ' of ' + total));
        summary.append(' · Updated ' + this.relative(o.updatedAt || activeStage.at || o.createdAt));
        meta.append(summary);

        const actions = this.el('div', 'ios__actions');
        const detailsId = 'ios-details-' + o.orderNumber.replace(/\W/g, '') + '-' + (this.closest('[id^="shopify-section"]')?.id || '');
        const toggle = this.el('button', 'ios__toggle');
        toggle.type = 'button';
        toggle.setAttribute('aria-controls', detailsId);
        toggle.append(this.el('span', null, 'Details'));
        toggle.insertAdjacentHTML('beforeend', svg('chevron'));
        const refresh = this.el('button', 'ios__link ios__refresh');
        refresh.type = 'button';
        refresh.innerHTML = svg('refresh');
        refresh.append(this.el('span', null, 'Refresh'));
        refresh.addEventListener('click', () => this.load(this.lastQuery || {}, true));
        actions.append(toggle, refresh);
        if (this.dataset.signedIn !== 'true') {
          const other = this.el('button', 'ios__link');
          other.type = 'button';
          other.innerHTML = svg('search');
          other.append(this.el('span', null, 'Another order'));
          other.addEventListener('click', () => {
            this.results.replaceChildren();
            this.showMessage('');
            this.form.reset();
            this.form.elements.order.focus();
          });
          actions.append(other);
        }
        meta.append(actions);
        card.append(meta);

        // Expandable detailed timeline
        const details = this.el('div', 'ios__details');
        details.id = detailsId;
        const inner = this.el('div');
        const list = this.el('ol', 'ios__steps');
        list.setAttribute('aria-label', 'Order progress');
        timeline.forEach((s, i) => {
          const li = this.el('li', 'ios__step ios__step--' + s.state);
          if (i === active && !complete) li.setAttribute('aria-current', 'step');
          li.append(this.el('span', 'ios__dot'));
          li.append(this.el('span', 'ios__step-label', s.label));
          const stateText = { done: 'Completed', current: 'In progress', attention: 'Action needed', upcoming: 'Coming up' }[s.state];
          li.append(this.el('span', 'ios__step-date', s.at ? this.formatDate(s.at, false) : ''));
          li.append(this.el('span', 'ios__visually-hidden', stateText));
          if (s.state === 'current' || s.state === 'attention') li.append(this.el('p', 'ios__step-desc', this.describe(s)));
          list.append(li);
        });
        inner.append(list);
        details.append(inner);
        card.append(details);

        const setOpen = (open) => {
          details.classList.toggle('is-open', open);
          toggle.setAttribute('aria-expanded', String(open));
          toggle.firstChild.textContent = open ? 'Hide details' : 'Details';
          if (open) this.open.add(o.orderNumber); else this.open.delete(o.orderNumber);
        };
        setOpen(this.open.has(o.orderNumber));
        toggle.addEventListener('click', () => setOpen(!details.classList.contains('is-open')));
        card._setOpen = setOpen;
        return card;
      }

      /** Clicking a stepper node opens the details and highlights that stage. */
      reveal(card, index) {
        card._setOpen(true);
        const row = card.querySelectorAll('.ios__step')[index];
        if (!row) return;
        row.classList.add('is-flash');
        setTimeout(() => row.classList.remove('is-flash'), 900);
      }
    }
    customElements.define('impact-order-status', ImpactOrderStatus);
  }

  } catch(e) { console.error(e); }
})();
})();
